import React, { useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom';
// import $ from 'jquery';

// import 'select2/dist/css/select2.css';
// import 'select2/dist/js/select2.min.js';
import Header from './Header'
import axios from 'axios';
import { getImageUrl } from '../utils';
import { Country } from 'country-state-city';

const Player = () => {
    const [players, setPlayers] = useState([]);
    const modalRef = useRef(null);
    const location = useLocation();
    const [selectedPlayerName, setSelectedPlayerName] = useState([]);
    const selectedPlayer = location.state;
    // const [selectedPlayerFromDropdown, setSelectedPlayerFromDropdown] = useState(null);
    const [bothPlayer, setBothPlayer] = useState([]);
    const [countryMapping, setCountryMapping] = useState({});

    const getFlagUrl = (countryCode) => {
        return `https://flagcdn.com/w80/${countryCode.toLowerCase()}.png`;
    };

    // useEffect(() => {
    //     if (players.length > 0) {
    //         $('#selectPlayer').select2({
    //             placeholder: 'Select a Player',
    //             maximumSelectionLength: 2,
    //             allowClear: false,
    //         }).on('change', function () {
    //             const selectedPlayerName = $(this).val();
    //             const playerData = players.find(r => r.name === selectedPlayerName);
    //             setSelectedPlayerFromDropdown(playerData);
    //         });
    //     }
    // }, [players]);

    const extractCountryName = (address) => {
        const parts = address.split(',').map(part => part.trim());
        console.log(parts, "Address Parts");
        return parts[parts.length - 1];
    };

    const getCountryCode = (countryName) => {
        return countryMapping[countryName] || '';
    };

    useEffect(() => {
        const countryList = Country.getAllCountries();
        const mapping = countryList.reduce((acc, country) => {
            acc[country.name] = country.isoCode;
            return acc;
        }, {});
        setCountryMapping(mapping);
    }, []);


    useEffect(() => {
        const fetchPlayers = async () => {
            try {
                const response = await axios.get(process.env.REACT_APP_USERS_LIST);
                setPlayers(response.data.data.list);
            } catch (error) {
                console.error('Error fetching player data:', error);
            }
        };
        fetchPlayers()
    }, [])

    useEffect(() => {
        const getPlayersData = async () => {
            const response = await axios.get(process.env.REACT_APP_PLAYERS_COMPARE_API, {
                params: {
                    playerEmail: selectedPlayer?.email,
                    opponentEmail: selectedPlayerName?.email
                }

            })
            setBothPlayer(response.data.data);
            console.log(response.data.data, "rrrr")
        }
        getPlayersData()
    }, [selectedPlayer, selectedPlayerName?.email])

    const handlePlayerSelect = (player) => {

        console.log(player, "pppp")
        setSelectedPlayerName(player);

        const modalElement = document.getElementById('playerModal');

        if (modalElement) {
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) {
                modal.hide();
            } else {
                const newModal = new window.bootstrap.Modal(modalElement);
                newModal.hide();
            }
        }
    };

    return (

        <div>
            <Header />
            <>
                <section className="stats-section spacer">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-sm-11 col-md-10">
                                <div className="match-player-stats">
                                    <div className="match-player-blk">
                                        <div className="match-player-info">
                                            <div className="match-player-img">
                                                <img src={getImageUrl(selectedPlayer?.profileImage)} alt="player" />
                                            </div>
                                            <div className="match-player-name" style={{ backgroundColor: '#344BFD' }}>
                                                <h2>{selectedPlayer?.name}</h2>
                                            </div>
                                        </div>
                                        <div className="vs-divider">vs</div>
                                        <div className="match-player-info">
                                            <div className="match-player-img">
                                                <img src={bothPlayer?.otherPlayer?.profileImage ? getImageUrl(bothPlayer?.otherPlayer?.profileImage) : 'assets/images/dummy-user.png'} alt="player" />
                                            </div>
                                            <div className="select-player">
                                                <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#playerModal">
                                                    {selectedPlayerName.name ? selectedPlayerName.name : 'Select a Player'}
                                                </button>

                                                {/* <select className="form-select" id="selectPlayer">
                                                    <option value="">Select a Player</option>
                                                    {players
                                                        .filter(player => player.name !== selectedPlayer?.name)
                                                        .map((player) => (
                                                            <option key={player.email} value={player.name}>
                                                                {player.name}
                                                            </option>
                                                        ))}
                                                </select> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="match-vs-stats">
                                        <div className="match-vs-item">
                                            <div className="stats-info">
                                                <h3>{selectedPlayer?.wins}</h3>
                                            </div>
                                            <div className="stats-info">
                                                <p>Wins</p>
                                            </div>
                                            <div className="stats-info">
                                                <h3>{bothPlayer?.otherPlayer?.win || 0}</h3>
                                            </div>
                                        </div>
                                        <div className="match-vs-item">
                                            <div className="stats-info">
                                                <h3>{selectedPlayer?.losses}</h3>
                                            </div>
                                            <div className="stats-info">
                                                <p>Losses</p>
                                            </div>
                                            <div className="stats-info">
                                                <h3>{bothPlayer?.otherPlayer?.loss || 0}</h3>
                                            </div>
                                        </div>
                                        <div className="match-vs-item">
                                            <div className="stats-info">
                                                <h3>{selectedPlayer?.skunks}</h3>
                                            </div>
                                            <div className="stats-info">
                                                <p>Skunks</p>
                                            </div>
                                            <div className="stats-info">
                                                <h3>{bothPlayer?.otherPlayer?.skunk || 0}</h3>
                                            </div>
                                        </div>
                                        <div className="match-vs-item">
                                            <div className="stats-info">
                                                <h3>{selectedPlayer?.goldenBreak || 0}</h3>
                                            </div>
                                            <div className="stats-info">
                                                <p>Golden break</p>
                                            </div>
                                            <div className="stats-info">
                                                <h3>{bothPlayer?.otherPlayer?.goldenBreak || 0}</h3>
                                            </div>
                                        </div>
                                        <div className="match-vs-item">
                                            <div className="stats-info">
                                                <h3>{selectedPlayer?.misses}</h3>
                                            </div>
                                            <div className="stats-info">
                                                <p>Total Misses</p>
                                            </div>
                                            <div className="stats-info">
                                                <h3>{bothPlayer?.otherPlayer?.totalMiss || 0}</h3>
                                            </div>
                                        </div>
                                        <div className="match-vs-item">
                                            <div className="stats-info">
                                                <h3>{selectedPlayer?.scratch}</h3>
                                            </div>
                                            <div className="stats-info">
                                                <p>Total Scratches</p>
                                            </div>
                                            <div className="stats-info">
                                                <h3>{bothPlayer?.otherPlayer?.totalScratches || 0}</h3>
                                            </div>
                                        </div>
                                        <div className="match-vs-item">
                                            <div className="stats-info">
                                                <h3>{selectedPlayer?.winLossRatio}</h3>
                                            </div>
                                            <div className="stats-info">
                                                <p>Win/loss %</p>
                                            </div>
                                            <div className="stats-info">
                                                <h3>{bothPlayer?.otherPlayer?.winLossRatio || 0}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="modal fade vt-playerModal" id="playerModal" tabIndex="-1" aria-labelledby="playerModalLabel" aria-hidden="true" ref={modalRef}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body p-0">
                                <div className="modal-content-wrapper position-relative">
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    <div className="modal-heading">
                                        <h5 className="modal-title text-center text-white mx-auto w-100" id="playerModalLabel">Select a Player</h5>
                                    </div>
                                    <ul className="list-group">
                                        {players
                                            .filter(player => player.name !== selectedPlayer?.name)
                                            .map((player) => {

                                                const countryName = extractCountryName(player.address);

                                                const countryCode = getCountryCode(countryName);

                                                return (
                                                    <li key={player.email} className="list-group-item" onClick={() => handlePlayerSelect(player)}>
                                                        <span className='modal-player-info'>
                                                            <span className='modal-player-img'>
                                                                <img src={getImageUrl(player.profileImage)} alt="player" className="player-image" />
                                                            </span>
                                                            <span className='modal-player-name text-truncate'>{player.name}</span>
                                                        </span>
                                                        <span className='modal-player-country'>
                                                            <img src={countryCode ? getFlagUrl(countryCode) : '/assets/images/global2.png'} alt={`${countryName} flag`} className="flag-image" />
                                                        </span>
                                                    </li>
                                                )
                                            })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </div>
    )
}

export default Player